import emoji from 'react-easy-emoji'

export const getFileType = file => file && file.type.split('/')[0]

export const getFileFormat = file => {
  const lastDotIndex = file.name.lastIndexOf('.')
  const formatFromName = file.name.slice(lastDotIndex + 1)

  // For some reason mov file has 'quicktime' in field type, because of that we handle mov files manually
  if (formatFromName === 'mov') {
    return 'mov'
  } else {
    return file.type.split('/')[1]
  }
}

export function renderTextWithEmoji(input = '') {
  /*
  This function is responsible for rendering text strings that include emojis.
  The function leverages the 'react-easy-emoji' library which allows us to parse
  any unicode emoji characters included in the text.

  Different emoji image datasets can be used depending on the preferred design style.
  Below are examples of datasets for different platforms:

  - Twitter: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/'
  - Facebook: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-facebook/15.0.1/img/facebook/64/'
  - Apple: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/15.0.1/img/apple/64'

  However, due to certain emoji characters (e.g., '1️⃣', '2️⃣', '⬇️', '✍️', '🗣', '❤️', '1⃣', '8⃣') not
  being available or correctly rendered with the Facebook and Apple datasets, we
  choose to use Twitter's Twemoji dataset.
  */

  const baseUrl = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/'

  return emoji(input, {
    baseUrl,
    size: ''
  })
}
